import { render, staticRenderFns } from "./LoadButton.vue?vue&type=template&id=15622ef0&"
import script from "./LoadButton.vue?vue&type=script&lang=js&"
export * from "./LoadButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports